import { WHO_WE_WORK_WITH } from "@/lib/siteContent";

export const WhoWeWorkWith = () => {
  return (
    <section
      id="who"
      data-testid="who-section"
      className="py-24 sm:py-32 border-t border-[#E5E7EB] bg-[#F9FAFB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.25em] text-[#6B7280] mb-6">
            Who we work with
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl tracking-tight leading-tight text-[#0F2A44]">
            Built for small carriers
            <br />
            <span className="italic">who want to stay small — and profitable.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {WHO_WE_WORK_WITH.map((card, i) => (
            <div
              key={card.title}
              data-testid="who-card"
              className="bg-white border border-[#E5E7EB] p-8 lg:p-10 transition-colors duration-300 hover:border-[#D4AF7F] group"
            >
              <div className="text-xs uppercase tracking-[0.25em] text-[#D4AF7F] mb-6">
                0{i + 1}
              </div>
              <h3 className="font-serif text-2xl text-[#0F2A44] mb-4 leading-snug">
                {card.title}
              </h3>
              <p className="text-[#1A1A1A]/75 leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
